import React, { useState, useEffect } from "react";
import { fetchNews } from "../utils/newsApi";
import { motion, AnimatePresence } from "framer-motion";
import './LatestNews.css';

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

export default function LatestNews() {
  const [news, setNews] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    fetchNews().then((data) => setNews(data || []));
  }, []);

  const openModal = (item) => {
    setSelectedNews(item);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedNews(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className="container-fluid py-5 news-section overflow-hidden">
      <div className="container p-0">
        <motion.div 
          className="text-center pb-5"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="section-title px-5">
            <span className="px-2">Updates</span>
          </p>
          <h1 className="mb-4 display-4 font-weight-bold">Latest News & Events</h1>
        </motion.div>
        
        <div className="row">
          {news.slice(0, 3).map((item, idx) => (
            <motion.div 
              className="col-lg-4 col-md-6 mb-4" 
              key={item.id || idx}
              variants={itemVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
            >
              <div className="latest-news-card h-100">
                <div className="news-content">
                  <div className="news-date-strip">
                    <div className="date-icon">
                       <i className="fa fa-calendar-alt"></i>
                    </div>
                    <span className="date-text">{item.date ? item.date.split(',')[0] : 'Upcoming'}</span>
                  </div>
                  
                  <h4 className="news-title">{item.title}</h4>
                  <p className="news-summary">{item.summary}</p>
                  
                  <div className="news-footer">
                    <span className="read-more-link" onClick={() => openModal(item)}>
                       Read More <i className="fa fa-arrow-right"></i>
                    </span>
                    <span className="news-category-tag">{item.category || 'Announcement'}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        
        <motion.div 
          className="text-center mt-5"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <button className="btn btn-primary px-5 py-3 rounded-pill font-weight-bold shadow-lg">
            Explore All Updates
          </button>
        </motion.div>
      </div>

      <AnimatePresence>
        {selectedNews && (
          <motion.div 
            className="news-modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeModal}
          >
            <motion.div 
              className="news-modal-content"
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="news-modal-close" onClick={closeModal}>
                &times;
              </button>
              <div className="modal-date-tag">
                <i className="fa fa-calendar-alt mr-2"></i>
                {selectedNews.date}
              </div>
              <h2 className="modal-title">{selectedNews.title}</h2>
              <div className="modal-body">
                {selectedNews.content ? (
                   <div dangerouslySetInnerHTML={{ __html: selectedNews.content }} />
                ) : (
                  <>
                    <p className="font-weight-bold lead">{selectedNews.summary}</p>
                    <p>
                       For more information regarding this announcement, please contact the school administration 
                       office or check your parent portal for official documents. We look forward to your participation 
                       and engagement in school events.
                    </p>
                  </>
                )}
              </div>
              <div className="mt-4 pt-4 border-top">
                <button className="btn btn-secondary rounded-pill px-4" onClick={closeModal}>
                   Close Details
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
